import { DateInput, useTranslate } from "react-admin";

export const RaDateInput = ({ label, source, ...props }) => {
    const translate = useTranslate();

    return (
        <DateInput
            label={label || `equip.${source}`}
            source={source}
            title={translate(label || `equip.${source}`)}
            {...props}
        />
    );
};
